import { render } from "./payment-method-card.vue?vue&type=template&id=03b64369"
import script from "./payment-method-card.vue?vue&type=script&lang=js"
export * from "./payment-method-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__